var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body bg-white-2 q-pa-lg overflow-auto relative-position"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in","appear":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }